import React from 'react';
import { Hidden } from '@mui/material';
import {
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
    GridToolbarExport,
} from '@mui/x-data-grid';
import EmployeeDeactivateCell from './EmployeeDeactivateCell';
import { employeeStatusValueGetter } from '../../utils/columnValueGetters';

export function createEmployeeStatusColumn(onDeactivate, { width = 170 } = {}) {
    return {
        field: 'employeeStatus',
        headerName: 'Status',
        width,
        headerClassName: 'header',
        sortable: true,
        filterable: true,
        type: 'singleSelect',
        valueOptions: ['Active', 'Deactivated'],
        valueGetter: employeeStatusValueGetter,
        renderCell: (cellValues) => (
            <EmployeeDeactivateCell cellValues={cellValues} onDeactivate={onDeactivate} />
        ),
    };
}

export function EmployeeDataGridToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton />
            <Hidden smDown>
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
            </Hidden>
            <GridToolbarExport />
        </GridToolbarContainer>
    );
}
